import { useEffect, useState } from 'react';
import { useRealtimeStatus } from './store';

/** Uma queda curta (deploy, troca de rede) se resolve sozinha: só avisa se passar disto. */
export const NOTICE_DELAY_MS = 2_500;

export type ConnectionNotice = 'reconnecting' | 'paused' | null;

/**
 * O aviso de conexão que a tela deve mostrar. `paused` (outra aba assumiu) aparece na hora porque
 * exige uma ação; `reconnecting` só depois de um tempo, para não piscar a cada oscilação.
 */
export function useConnectionNotice(): ConnectionNotice {
  const status = useRealtimeStatus();
  const [waited, setWaited] = useState(false);
  useEffect(() => {
    if (status !== 'reconnecting') return;
    const timer = setTimeout(() => setWaited(true), NOTICE_DELAY_MS);
    return () => {
      clearTimeout(timer);
      setWaited(false);
    };
  }, [status]);
  if (status === 'paused') return 'paused';
  return status === 'reconnecting' && waited ? 'reconnecting' : null;
}
